import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Breadcrumb, Button, Timeline, } from "antd";
import * as actions from './redux/actions';

export class ExamPrepare extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    let pathname = this.props.location.pathname;
    let id = pathname.slice(pathname.lastIndexOf("/") + 1, pathname.length);

    //获取试卷详情
    this.props.actions.fetchQuesExam({ ID: id });
    //获取试卷题型
    this.props.actions.fetchGetExamQuesList({ examPaperId: id })
  }
  renderItem(item, index) {
    return (
      <Timeline.Item
        key={index}
        dot={<img src={require("../../images/circle.png")} alt="" />}
      >
        <h4>{item.QuestionType_Name}&nbsp;&nbsp;(每题{item.Sorce}分,&nbsp;&nbsp;共{item.Num}题,&nbsp;&nbsp;共{item.Sorce * item.Num}分)</h4>
        <div className="pop-mark">
          {item.QuestionType_Mark}
        </div>
      </Timeline.Item>
    )
  }
  render() {
    const { totalScore, totalQues, fetchQuesExamSuccess, fetchGetExamQuesListSuccess, fetchGetExamQuesListPending } = this.props.quesStore;

    if (!fetchQuesExamSuccess) return null;
    let Data = fetchQuesExamSuccess;
    return (
      <div className="ques-store-exam-prepare">
        <div className="content">
          <div className="banner">
            <img src={require("../../images/banner8.png")} alt="" />
          </div>
          <div className="detail">
            <h1>
              <Breadcrumb separator=">">
                <Breadcrumb.Item href="/center/startExer/0">开始做题</Breadcrumb.Item>
                <Breadcrumb.Item href={Data.ExamPaperType === 0 ? "/center/startExer/2" : "/center/startExer/1"}>{Data.ExamPaperType === 0 ? "模拟试卷" : "历年真题"}</Breadcrumb.Item>
                <Breadcrumb.Item>试卷详情</Breadcrumb.Item>
              </Breadcrumb>
            </h1>
            <h2>
              {Data.Title}
            </h2>
            <table>
              <thead>
                <tr>
                  {Data.Year !== 0 && <th>年份</th>}
                  <th>组卷方式</th>
                  <th>总分数</th>
                  <th>合格分数</th>
                  <th>总题数</th>
                  <th>作答时间</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Data.Year !== 0 && <td>{Data.Year}</td>}
                  <td>{Data.ExamPaperDo === 0 ? "自动组卷" : "手动组卷"}</td>
                  <td>{totalScore}分</td>
                  <td>{Data.PassScore}分</td>
                  <td>{totalQues}题</td>
                  <td>{Data.Time}分钟</td>
                </tr>
              </tbody>
            </table>
            <div className="btn">
              <Button type="theme" onClick={() => {
                let pathname = this.props.location.pathname;
                let id = pathname.slice(pathname.lastIndexOf("/") + 1, pathname.length);
                this.props.history.push(`/ques/exam/page/${id}`);
              }}>开始考试</Button>
            </div>
          </div>
          <div className="questions">
            <h3>
              <span>题型介绍</span>
            </h3>
            <div className="questions-time-line">
              <Timeline pending={fetchGetExamQuesListPending}>
                {
                  fetchGetExamQuesListSuccess && fetchGetExamQuesListSuccess.length > 0 &&
                  fetchGetExamQuesListSuccess.map((item, index) => (
                    this.renderItem(item, index)
                  ))
                }
              </Timeline>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExamPrepare);



// WEBPACK FOOTER //
// ./src/features/ques-store/ExamPrepare.js